"use client";
import { jsx as l } from "react/jsx-runtime";
import { memo as o } from "react";
import e from "../components/Icon/SvgIcon.js";
const t = (a) => /* @__PURE__ */ l(
  e,
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8.178 3.376h.067c.796.05 1.587.246 2.312.594.546.262 1.037.695 1.442 1.11.395-.41.876-.849 1.421-1.11a6.1 6.1 0 0 1 2.32-.594h.066a6.13 6.13 0 0 1 3.804 1.58 5.9 5.9 0 0 1 1.435 1.876c.343.717.535 1.494.565 2.282v.008a6 6 0 0 1-.333 2.431 6.2 6.2 0 0 1-1.324 2.157l-7.043 6.57a1.4 1.4 0 0 1-.922.346 1.4 1.4 0 0 1-.9-.329l-.02-.017-7.007-6.516a6.05 6.05 0 0 1-1.363-2.218l-.002-.006a6 6 0 0 1-.292-2.512c.043-.83.265-1.642.655-2.383a6.1 6.1 0 0 1 1.59-1.93 5.98 5.98 0 0 1 3.529-1.34Zm.023 1.25a4.72 4.72 0 0 0-2.758 1.056l-.005.004c-.534.431-.97.951-1.269 1.533l-.003.006A4.5 4.5 0 0 0 3.65 9.14c-.07.667.015 1.349.232 2 .22.637.574 1.22 1.046 1.722l6.977 6.488a.15.15 0 0 0 .085.024.15.15 0 0 0 .084-.024l7.01-6.54a5 5 0 0 0 1.017-1.68 4.7 4.7 0 0 0 .26-1.98 4.6 4.6 0 0 0-.442-1.779 4.6 4.6 0 0 0-1.135-1.479l-.013-.01a4.88 4.88 0 0 0-3-1.257 4.8 4.8 0 0 0-1.809.47c-.516.248-.996.772-1.499 1.325a.625.625 0 0 1-.928-.004c-.487-.545-.998-1.07-1.518-1.32a5 5 0 0 0-1.815-.471Z",
        clipRule: "evenodd"
      }
    )
  }
), i = o(t);
export {
  i as Heart,
  i as default
};
